import type {
  AssignedVehicle,
  AssignedVehicleStorageLocation,
} from '@bambi/api-client/schemas';

import type {
  VehicleRead,
  VehicleStorageLocationRead,
} from 'src/common/external/bambi-api/bambiApi';

export const convertVehicleToAssignedVehicle = (
  vehicle: VehicleRead
): AssignedVehicle => {
  return {
    vehicle: vehicle.id,
    nickname: vehicle.nickname || '',
    category: vehicle.category,
    color: vehicle.color || '',
    make: vehicle.make || '',
    model: vehicle.model || '',
    year: vehicle.year || 0,
    license_plate: vehicle.license_plate || '',
    storage_location: patchStorageLocation(vehicle.storage_location),
  };
};

/**
 * Fills in the expected type with empty values for the fields
 * that are not present in the VehicleStorageLocationRead object.
 */
export const patchStorageLocation = (
  storageLocation: VehicleStorageLocationRead
): AssignedVehicleStorageLocation => {
  return {
    address_number: '',
    country: '',
    municipality: '',
    neighborhood: '',
    postal_code: '',
    region: '',
    sub_region: '',
    street: '',
    unit_number: '',
    unit_type: '',
    latitude: 0,
    longitude: 0,
    label: storageLocation.label,
  };
};
